import { useQuery } from 'react-query';
import { foldersKeys } from './foldersKeys';
import { getAllFolders } from 'lib/const/Folders';
import { EXPRESS_API } from 'configs/api/expressApi';
import { useTranslation } from 'react-i18next';

export type Folder = {
  access?: string;
  folderId: number | string;
  name: string;
  isDeletable: boolean;
  userId?: number;
  isFolderShared?: boolean;
  sharedBy?: string;
  includeNewUsers?: boolean;
  folderAccessPermission?: string;
};

export type GetFolderParams = {
  getShared: boolean;
};

type FolderResponse = {
  folders: Folder[];
};

const getFolders = async (
  params?: GetFolderParams
): Promise<FolderResponse> => {
  return (await EXPRESS_API.get(`folders/new`, { params })).data;
};

export const useGetFolders = (params?: GetFolderParams) => {
  const { t } = useTranslation();
  const allFolders = getAllFolders(t);

  return useQuery(foldersKeys.all(), () => getFolders(params), {
    select: (data: FolderResponse) => {
      const folders: Folder[] = (data && data.folders) || [];

      return [
        ...folders,
        {
          folderId: allFolders.value,
          name: allFolders.label,
          isDeletable: false,
        },
      ];
    },
  });
};
